import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "../pages/hompage/HomePage";
import PrivateRoute from "../components/PrivateRouter";
import HomeAdmin from "../pages/Admin/HomeAdmin";
import Login from "../pages/login/Login";

import HomeNH from "../pages/NH/HomeNH";
import SlotNH from "../pages/NH/Slot";
import TableGameNew from "../pages/NH/TableGameNew";
import WintoolForward from "../pages/NH/WintoolForward";

const Approuter = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Routes>
              <Route path="/" element={<Navigate to="/homeNH" replace />} />
              <Route path="/home" element={<HomePage />} />
              <Route path="/admin" element={<HomeAdmin />} />
              <Route path="/homeNH" element={<HomeNH />} />
              <Route path="/NH" element={<HomeNH />} />
              <Route path="/NH/slot/:room" element={<SlotNH />}/>
              <Route path="/NH/table/:room" element={<TableGameNew/>} />
              <Route path="/wintool-forward" element={<WintoolForward />} />
            </Routes>
          </PrivateRoute>
        }
      />

    </Routes>
  );
};

export default Approuter;
